import { navigate } from "gatsby";

import actionName from "../action-creator";
import { VIRTUAL_TRYON } from "./virtual-tryon.reducer";
import {
    restoreVirtualTryOnInitialStateAction,
    setVirtualTryOnAction,
    types,
} from "./virtual-tryon.actions";
import endpoints from "../../config/endpoints";
import { actions, sendApiRequest } from "../api/api.actions";
import { statusIdle } from "../ui/ui.actions";
import { setAlert } from "../alerts/alerts.actions";
import { getAbsolutePath } from "../../apps/utility/routes.utility";

const virtualTryOnMiddleware = (state) => (next) => (action) => {
    const { dispatch } = state;
    const { type, payload, meta } = action;

    next(action);

    let fetchConfig;

    switch (type) {
        case actionName(VIRTUAL_TRYON, types.GET):
            fetchConfig = {
                url: endpoints.stylizations.single(payload.stylizationId, payload.guid),
                method: "GET",
                withCredentials: true,
                // params: {
                //     expand: "products",
                // },
            };
            meta.useAlternateApi = true;
            dispatch(sendApiRequest(fetchConfig, meta));
            break;
        case actionName(VIRTUAL_TRYON, `${types.GET} ${actions.API_SUCCESS}`):
            dispatch(setVirtualTryOnAction(payload));
            break;

        case actionName(VIRTUAL_TRYON, types.CREATE):
            console.log("VIRTUAL_TRYON POST");
            dispatch(setVirtualTryOnAction({}));
            fetchConfig = {
                url: endpoints.virtualtry.create,
                method: "POST",
                withCredentials: true,
                data: payload,
            };
            meta.useAlternateApi = true;
            dispatch(sendApiRequest(fetchConfig, meta));
            break;
        case actionName(VIRTUAL_TRYON, `${types.CREATE} ${actions.API_SUCCESS}`):
            console.log("VIRTUAL_TRYON save: ", payload);
            dispatch(setVirtualTryOnAction(payload));
            // navigate(getAbsolutePath('GENERATOR_STYLIZATION_CONGRATULATIONS'), { replace: true })
            // {`${getAbsolutePath("GENERATOR_STYLIZATION")}/${stylizationId}`}
            //navigate(getAbsolutePath("GENERATOR_STYLIZATION_CONGRATULATIONS").replace(":stylizationId",payload.stylizationId), { replace: true })
            break;
        case actionName(VIRTUAL_TRYON, `${types.CREATE} ${actions.API_FAIL}`):
            dispatch(
                setAlert(
                    {
                        type: "error",
                        content: "Nie udało się wygenerować ubrań. Spróbój ponownie później.",
                    },
                    meta
                )
            );
            break;

        case actionName(VIRTUAL_TRYON, types.UPDATE):
            fetchConfig = {
                url: endpoints.stylizations.update(payload.stylizationId),
                method: "PATCH",
                withCredentials: true,
                data: payload.data,
            };
            dispatch(sendApiRequest(fetchConfig, meta));
            break;
        case actionName(VIRTUAL_TRYON, `${types.UPDATE} ${actions.API_FAIL}`):
            dispatch(
                setAlert(
                    {
                        type: "error",
                        content: "Nie udało się zapisać zmian. Spróbój ponownie później.",
                    },
                    meta
                )
            );
            break;

        case actionName(VIRTUAL_TRYON, types.DELETE):
            fetchConfig = {
                url: endpoints.stylizations.delete(payload),
                method: "DELETE",
                withCredentials: true,
            };
            dispatch(sendApiRequest(fetchConfig, meta));
            break;
        case actionName(VIRTUAL_TRYON, `${types.DELETE} ${actions.API_SUCCESS}`):
            dispatch(
                setAlert(
                    {
                        type: "success",
                        content: "Stylizacja została usunięta.",
                    },
                    meta
                )
            );
            break;
        case actionName(VIRTUAL_TRYON, `${types.DELETE} ${actions.API_FAIL}`):
            dispatch(
                setAlert(
                    {
                        type: "error",
                        content: "Nie udało się usunąć stylizacji. Spróbój ponownie później.",
                    },
                    meta
                )
            );
            break;

        case actionName(VIRTUAL_TRYON, types.CLEAR):
            dispatch(statusIdle({ actionName: types.CLEAR, entity: SINGLE_STYLIZATION }));
            dispatch(restoreVirtualTryOnInitialStateAction());
            break;

        default:
            break;
    }
};

export default virtualTryOnMiddleware;
